var map = {
	"./bonk.png": 8411,
	"./btc.png": 98387,
	"./eth.png": 82469,
	"./jup.png": 66106,
	"./pyth.png": 99224,
	"./sol.png": 38304,
	"./sol_market.png": 92679,
	"./usdc.png": 79782,
	"./wbtc.png": 21712,
	"./wen.png": 36778,
	"./weth.png": 28030,
	"./wif.png": 1857
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 29343;